module.exports = __webpack_public_path__ + "static/assets/0823d90f9e418868c7fea7d82573d656.png";